import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { MedicoService } from 'src/app/services/medico.service';
import { CanjeMedico } from 'src/app/models/redimir.interface';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-canje-medico-solicitud',
  templateUrl: './canje-medico-solicitud.component.html',
  styleUrls: ['./canje-medico-solicitud.component.scss']
})
export class CanjeMedicoSolicitudComponent {
  canjeForm!: FormGroup;
  idMedico!: number;
  constructor(
    private authService: AuthService,
    private activedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private messageService: MessageService,
    private medicoService: MedicoService,
  ) {
    this.canjeForm = this.crearFormulario();
    this.idMedico = this.activedRoute.snapshot.params['id'];
  }

  crearFormulario(): FormGroup {
    return this.fb.group({
      redimir: [0, Validators.required],
      fechaInicio: ['', Validators.required],
      concepto: ['',],
      descripcion: ['']
    });
  }
  onSubmit(): void {
    const fecha = new DatePipe("es-mx");
    const { redimir, fechaInicio, descripcion } = this.canjeForm.value;
    const canje: CanjeMedico = <CanjeMedico>{ redimir, fechaInicio, concepto: 1, descripcion };
    canje.fechaInicio = <string>fecha.transform(fechaInicio, 'yyyy-MM-dd')?.toString();
    if (this.idMedico != 0) {
      canje.status = 1;
      canje.fk_medico = this.idMedico;
      this.medicoService.setRedimir(canje)
        .subscribe({
          next: (resp) => { this.showSuccess(resp.mensaje); console.log(resp) },
          error: (err: HttpErrorResponse) => { this.showError(err.error.message); console.log(err) }
        });

    }

  }
  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  get f() {
    return this.canjeForm.controls;
  }
}
